<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.JoinderRequest.title">
      <v-row>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.radioButton"
            :value.sync="formModel.casePartyRole"
            :label="local.caseRelatedRequest.JoinderRequest.casePartyRole"
            :items="casePartyRole"
            item-value="id"
            item-text="name"
            validates="required"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
        <v-col cols="4">
          <naj-input
            v-if="selectedCasePartyRoleId && filteredPartyTypes"
            :type-id="formFieldType.selectbox"
            :label="local.partyTypeSelection.type"
            :value.sync="formModel.partyType"
            :items="filteredPartyTypes"
            item-text="name"
            item-value="id"
            validates="required"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
        <v-col
          v-if="isOfType(formModel,'person') && !isInheritor(formModel)"
          cols="4"
          class="my-auto"
        >
          <naj-input
            :type-id="formFieldType.checkbox"
            :label="local.partyTypeSelection.isOrganizationOwner"
            :value.sync="formModel.isOrganizationOwner"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>

    <person-type
      v-if="isPerson(formModel)"
      :form-model="formModel"
      :show-more-address-details="true"
      :allow-address-check="allowAddressCheck"
      :is-representative="false"
      :required="isPartyDataRequired"
      :view-mode="isViewMode"
    ></person-type>

    <firm-type
      v-if="isFirm(formModel)"
      :form-model="formModel"
      :show-more-address-details="true"
      :allow-address-check="allowAddressCheck"
      :required="isPartyDataRequired"
      :is-view-mode="isViewMode"
      :check-commercial-register-number-status="checkCommercialRegisterNumberStatus"
      :is-joinder-request="true"
    ></firm-type>

    <organization-type
      v-if="isOrganization(formModel)"
      :form-model="formModel"
      :show-more-address-details="true"
      :allow-address-check="allowAddressCheck"
      :required="isPartyDataRequired"
      :is-view-mode="isViewMode"
    ></organization-type>

    <government-type
      v-if="isGovernment(formModel)"
      :form-model="formModel"
      :required="true"
      :is-view-mode="isViewMode"
    ></government-type>

    <association-type
      v-if="isAssociation(formModel)"
      :form-model="formModel"
      :required="true"
      :is-view-mode="isViewMode"
    ></association-type>

    <embassy-type
      v-if="isEmbassy(formModel)"
      :form-model="formModel"
      :required="true"
      :is-view-mode="isViewMode"
    ></embassy-type>

    <institution-without-commercial-number-type
      v-if="isInstitutionWithoutCommercialRegisterNo(formModel)"
      :form-model="formModel"
      :required="true"
      :is-view-mode="isViewMode"
    ></institution-without-commercial-number-type>

    <human-society-type
      v-if="isHumanSociety(formModel)"
      :form-model="formModel"
      :required="true"
      :is-view-mode="isViewMode"
    ></human-society-type>

    <foreign-company-type
      v-if="isForeignCompany(formModel)"
      :form-model="formModel"
      :required="true"
      :is-view-mode="isViewMode"
    ></foreign-company-type>

    <contact-form
      v-if="formModel.partyType && isPerson(formModel)"
      :form-model="formModel.contact"
      :required="true"
      :mobile-required="true"
      :is-view-mode="isViewMode"
    ></contact-form>
  </div>
</template>

<script>
import { mode, socialIdentityTypeEnum, countriesEnum, casePartyRoleByIdEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers('LookupsModule');
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');
import PersonType from '../../../../lawsuit/components/step1/party-types/person-type';
import FirmType from '../../../../lawsuit/components/step1/party-types/firm-type';
import OrganizationType from '../../../../lawsuit/components/step1/party-types/organization-type';
import GovernmentType from '../../../../lawsuit/components/step1/party-types/government-type';
import EmbassyType from '../../../../lawsuit/components/step1/party-types/embassy-type';
import HumanSocietyType from '../../../../lawsuit/components/step1/party-types/human-society-type';
import ForeignCompanyType from '../../../../lawsuit/components/step1/party-types/foreign-company-type';
import AssociationType from '../../../../lawsuit/components/step1/party-types/association-type';
import InstitutionWithoutCommercialNumberType from '../../../../lawsuit/components/step1/party-types/institution-without-commercial-number-type';
import ContactForm from '../../../../lawsuit/components/step1/party-types/forms/contact-form';
import {
  isProsecutor,
  isRepresentative,
  isProsecutorOrDefendant,
  isPerson,
  isFirm,
  isOrganization,
  isGovernment,
  isEmbassy,
  isAssociation,
  isInstitutionWithoutCommercialRegisterNo,
  isHumanSociety,
  isForeignCompany,
  isAgent,
  isLawyer,
  isRepresentativeRole,
  isRegent,
  isGuardian,
  isOfType,
  isInheritor,
} from '../../../../lawsuit/helpers/utils';

export default {
  name: 'JoinderRequest',
  inject: ['$validator'],
  components: {
    PersonType,
    FirmType,
    OrganizationType,
    GovernmentType,
    EmbassyType,
    HumanSocietyType,
    ForeignCompanyType,
    AssociationType,
    InstitutionWithoutCommercialNumberType,
    ContactForm,
  },
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
    checkCommercialRegisterNumberStatus: {
      require: false,
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      caseParties: [],
      casePartyRoleByIdEnum,
      isProsecutor,
      isRepresentative,
      isProsecutorOrDefendant,
      isPerson,
      isFirm,
      isOrganization,
      isGovernment,
      isEmbassy,
      isAssociation,
      isInstitutionWithoutCommercialRegisterNo,
      isHumanSociety,
      isForeignCompany,
      isAgent,
      isLawyer,
      isRepresentativeRole,
      isRegent,
      isGuardian,
      isOfType,
      isInheritor,
    };
  },
  computed: {
    ...mapLUTState(['casePartyRole', 'partyTypes']),
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    filteredPartyTypes() {
      return this.partyTypes.filter(p => p.id !== 18 && p.id !== 19);
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
    selectedCasePartyRoleId() {
      return this.formModel.casePartyRole;
    },
    isPartyDataRequired() {
      return this.isProsecutor(this.formModel);
    },
    allowAddressCheck() {
      return this.isProsecutor(this.formModel);
    },
    partyTypeSelectionTitle() {
      if (this.selectedCasePartyRoleId) {
        return (
          this.local.common.the +
          (this.local.common[this.casePartyRoleByIdEnum[this.selectedCasePartyRoleId]] ||
            this.local.common.casePartyRoles[this.casePartyRoleByIdEnum[this.selectedCasePartyRoleId]])
        );
      }
      return (this.local.common.the + this.local.common.prosecutor);
    },
  },
  watch: {
    'formModel.casePartyRole'() {
      this.clearObject(this.formModel, [
        'applicantCasePartyId',
        'attachments',
        'case',
        'isPega',
        'representative',
        'requestReasons',
        'requestType',
        'casePartyRole',
        'partyType',
      ]);
    },
    'formModel.partyType'() {
      this.clearObject(this.formModel, [
        'applicantCasePartyId',
        'attachments',
        'case',
        'isPega',
        'representative',
        'requestReasons',
        'requestType',
        'casePartyRole',
        'partyType',
      ]);
    },
    'formModel.isOrganizationOwner'() {
      this.clearObject(this.formModel, [
        'isOrganizationOwner',
        'applicantCasePartyId',
        'attachments',
        'case',
        'isPega',
        'representative',
        'requestReasons',
        'requestType',
        'casePartyRole',
        'partyType',
      ]);
    },
  },
  mounted() {
    this.$set(this.formModel, 'workAddress', this.formModel.workAddress || {});
    this.$set(this.formModel, 'residenceAddress', this.formModel.residenceAddress || {});
    this.$set(this.formModel, 'placeAddress', this.formModel.placeAddress || {});
    this.$set(this.formModel, 'nationalAddress', this.formModel.nationalAddress || {});
    this.$set(this.formModel, 'contact', this.formModel.contact || {});
    this.$set(this.formModel, 'relatedPartiesInfo', this.formModel.relatedPartiesInfo || []);

    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };

    this.getCaseBasicParties(params)
      .then((res) => {
        this.caseParties = res.data;
      })
      .finally(() => (this.loading = false));
  },
  created() {
    this.getPartyTypes();
  },
  methods: {
    ...mapLUTActions(['getPartyTypes']),
    ...mapActions(['getCaseBasicParties']),
    clearObject(state, exceptArr) {
      for (const key in state) {
        if (Object.prototype.hasOwnProperty.call(state, key) && exceptArr.indexOf(key) === -1) {
          if (typeof state[key] === 'object') {
            this.clearObject(state[key], exceptArr);
          } else {
            state[key] = undefined;
          }
        }
      }
    },
    readCurrentUserInfo() {
      if (this.userInfo) {
        const socialTypeId = this.userInfo.socialIdType;
        this.$set(this.formModel, 'socialIdType', socialTypeId);
        this.$set(this.formModel, 'socialId', this.userInfo.socialId);
        this.$set(this.formModel, 'firstName', this.userInfo.firstName);
        this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
        this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
        this.$set(this.formModel, 'familyName', this.userInfo.familyName);
        this.$set(this.formModel, 'dateOfBirth', this.userInfo.dateOfBirth);
        this.$set(this.formModel, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
        this.$set(this.formModel, 'sex', this.userInfo.gender);
        this.$set(this.formModel, 'isRetrievedFromMoi', true);
        this.$set(this.formModel, 'fullName', this.userInfo.fullName);
      } else {
        this.$set(this.formModel, 'socialIdType', null);
        this.$set(this.formModel, 'socialId', null);
        this.$set(this.formModel, 'firstName', null);
        this.$set(this.formModel, 'fatherName', null);
        this.$set(this.formModel, 'grandFatherName', null);
        this.$set(this.formModel, 'familyName', null);
        this.$set(this.formModel, 'dateOfBirth', null);
        this.$set(this.formModel, 'nationalityCountryId', null);
        this.$set(this.formModel, 'sex', null);
        this.$set(this.formModel, 'isRetrievedFromMoi', false);
        this.$set(this.formModel, 'fullName', null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>